export default __webpack_public_path__ + "static/media/SL_Economics.3598b790.svg";